<template>
  <div class="outer-section Home">
    <!-- <RwvAdvertisement class="first-ad"></RwvAdvertisement> -->
    <!-- <RwvAdvertisement class="second-ad"></RwvAdvertisement> -->
    <b-container fluid>
      <b-row class="homeSelection">
        <b-col xl="4" md="5">
          <RwvVariantSelection @changedVariant="changedVariant" class="bg-light"></RwvVariantSelection>
        </b-col>
        <b-col xl="8" md="7">
          <Adsense
            class="RwvAdvertisement"
            data-ad-client="ca-pub-0281378002600422"
            data-ad-slot="1725038732"
            data-ad-test="on"
            data-ad-format="auto">
          </Adsense>
        </b-col>
      </b-row>
    </b-container>
    <RwvBookList :manufacturerSlug="manufacturerSlug" :authorSlug="authorSlug" :modelSlug="modelSlug" :variantSlug="variantSlug"></RwvBookList>
  </div>
</template>

<script>
import RwvBookList from '@/components/Books/BookList.vue'
import RwvVariantSelection from '@/components/VariantSelection.vue'
import RwvAdvertisement from '@/components/AdAdsense.vue'

export default {
  title: "Startseite | So wird's gemacht",
  name: 'Home',
  components: {
    RwvBookList,
    RwvVariantSelection,
    RwvAdvertisement
  },
  props: {
    tag: {
      type: String
    },
    authorSlug: {
      type: String,
      default: "dr-rueding-etzold"
    }
  },
  data() {
    return {
      manufacturerSlug: "",
      modelSlug: "",
      variantSlug: ""
    }
  },
  methods: {
    changedVariant(manufacturerSlug, modelSlug, variantSlug) {
      this.manufacturerSlug = manufacturerSlug
      this.modelSlug = modelSlug
      this.variantSlug = variantSlug
    }
  }
}
</script>

<style lang="scss">
.Home {
  .homeSelection {
    margin-bottom: 1rem;
    .RwvVariantSelection {
      max-width: 335px;
      padding: 15px;
      border-radius: 6px;
      box-shadow: 0 0 3px rgba(0,0,0,0.15);
      margin-left: auto;
      margin-right: auto;
    }
    .RwvAdvertisement {
      height: 175px;
      margin-bottom: 1rem;
    }
  }
  // .first-ad, .second-ad {
  //   width: 200px;
  //   min-height: 600px;
  //   position: absolute;
  // }
  // .first-ad {
  //   margin-left:-200px;
  // }
}
</style>
